export default __webpack_public_path__ + "assets/phonesIcon.e91481fd.png";